import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ToastContainer } from 'react-toastify';

// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';

// Custom CSS
import './index.css';

// Components
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { installGlobalErrorLogging } from './utils/errorLog';

// Report uncaught JS errors / promise rejections to the server error log
installGlobalErrorLogging();

// Create a client with optimized defaults for responsiveness
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,       // 5 minutes - data is "fresh" for this long
      cacheTime: 10 * 60 * 1000,       // 10 minutes - keep unused data in cache
      refetchOnMount: 'always',         // Refetch stale data when component mounts
      keepPreviousData: true,           // Show old data while fetching new (no flash)
    },
    mutations: {
      retry: 0,                         // Don't retry mutations (user can retry manually)
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable
            pauseOnHover
            theme="light"
            limit={3}
          />
        </AuthProvider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
); 